export default __webpack_public_path__ + "static/media/Proceedings-of-21st-AGM.714ba637.pdf";